import React from 'react';
import QRCode from "react-qr-code";
function CvPage() {
    const QRCodeCardSystem = (props) => {
        return(
            <div className='row col-10'>
                    <div className='col-4 align-self-center  '>
                        
                        <QRCode   value={props.link} size={120} />
                    </div>
                    <div className='col-8 text-start'>
                         
                         {
                            props.appLink ? <b> {props.appLink} </b>: 
                            <>
                                <h5 className='mb-1'>Live Demo</h5>
                                <a href={props.link}>{props.link}</a>
                                
                            </>

                         }
                         
                         <br />
                         <br />
                         CREDENTIALS :
                         <div className='row'>
                            <div className='col-6 algin-self-center'>
                                <div className='border-div p-2   mb-3' style={{backgroundColor: '#ccc9c6'}}>
                                    ID : {props.id}
                                </div>
                            </div>
                            <div className='col-6 algin-self-center'>
                                <div className='border-div p-2  ' style={{backgroundColor: '#ccc9c6'}}>
                                    PWD : {props.pwd}
                                </div>
                            </div>
                         </div>
                         
                         
                    </div> 
                </div>
            
        )
    }
    return (  <>
        
          
        <div style={{backgroundColor: '#d1d1d1'}} className='mb-4 p-3'>
            <div className='row '>
                <div className='col-8'>
                    <h1 className='display-3' style={{color:'#d4282b'}}>KHELIFI HOUSSEM</h1> 
                    <h3 className='text-secondary mt-0'>CASHIER</h3>
                </div>
                <div className='col-4'>
                    <div><span className='bi bi-whatsapp bi-sm' style={{color:'#d4282b'}}></span> : +216 96787676</div>
                    <div><span className='bi bi-envelope-at bi-sm' style={{color:'#d4282b'}}></span> : khelifihoussem53@gmail.com</div>
                    <div><span className='bi bi-geo-alt bi-sm' style={{color:'#d4282b'}}></span> : Ben Arous , Tunisia</div>
                    {/* <div><span className='bi bi-linkedin bi-sm' style={{color:'#d4282b'}}></span> : houssem-khelifi-66950016b/</div> */}
                </div>
            </div>
        </div>

        <div className='container'>
            <div className='mb-4 mt-3'>
                <h5 style={{color:'#d4282b'}}>DESCRIPTION</h5>
                <hr />
                <p>
                Motivated and detail-oriented cashier with 4 years of experience in providing exceptional customer service, 
                handling cash transactions, and maintaining a smooth checkout process. Skilled in operating point-of-sale (POS) systems,
                 managing inventory, and ensuring a positive shopping experience for customers. Adaptable, fast learner, and capable of thriving in fast-paced environments.
                </p>
            </div>
            <div className='mb-4 mt-3'>
                <h5 style={{color:'#d4282b'}}>KEY SKILLS</h5>
                <hr />
                <div className='row'>
                    <div className='col-6'>
                        <ul>
                            <li>Efficient cash handling and reconciliation</li>
                            <li>Strong customer service and communication skills</li>
                            <li>Proficient in operating POS systems and handling credit/debit transactions</li>
                            <li>Inventory management and stock replenishment</li>
                            <li>Conflict resolution and problem-solving</li>
                            <li>Multitasking and time management</li>
                            <li>Fluent in French and Arabic; basic proficiency in English                            </li>
                        </ul>
                    </div>
                    <div className='col-6'>
                        <ul>
                            <li>Leadership</li>
                            <li>Client Communication</li>
                            <li>Team Collaboration</li>
                            <li>Problem-Solving</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='mb-4 mt-3'>
                <h5 style={{color:'#d4282b'}}>LANGUAGES</h5>
                <hr />
                <div className='row'>
                    <div className='col-6'>
                         <h5 className='ms-3'>ENGLISH : fluent</h5>
                         <div class="progress" style={{height:7}}>
                            <div class="progress-bar " style={{width: '80%', background:'#c94d4f'}}> </div>
                        </div>
                    </div>
                    <div className='col-6'>
                        <h5 className='ms-3'>FRANCAIS : courante</h5>
                         <div class="progress" style={{height:7}}>
                            <div class="progress-bar " style={{width: '70%', background:'#c94d4f'}}> </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='mb-4 mt-3'>
                <h5 style={{color:'#d4282b'}}>EDUCATION</h5>
                <hr />
                <div className='row'>
                     <h3>Baccalauréat Degree , Section : MATH</h3>
                     <h5 className='ms-4'>Lycée Elkrib, Siliana, Tunisia</h5>
                     <h5 className='ms-4'>Graduated: 2014</h5>

                     <h3 className='mt-4'>Preparatory Studies in Math-Physics</h3>
                     <h5 className='ms-4'>IPEK (Institut Préparatoire aux Études d'Ingénieurs de Kairouan), Tunisia</h5>
                     <h5 className='ms-4'>2015-2017</h5>
                     <ul className='ms-4'>
                        <li>Completed the first year of preparatory studies in Math-Physics.</li>
                     </ul>
                </div>
            </div>
            <div className='breack-page-here'></div>
            <div className='mb-4 mt-3'>
                <h5 style={{color:'#d4282b'}}>EXPERIENCE</h5>
                <hr />
                <b>SEP 2021 -- JAN 2022 : Cashier</b>
                <div className='ms-5 text-start mb-3'>
                     
                    <ul>
                        <li>Operated cash registers, processed payments, and provided accurate change to customers.</li>
                        <li>Delivered exceptional service to ensure customer satisfaction and retention.</li>
                        <li>Maintained cleanliness and organization of the checkout area.</li>
                        <li>Managed inventory by restocking shelves and ensuring products were displayed neatly.</li>
                        <li>Assisted customers with inquiries and resolved complaints in a professional manner.</li>
                    </ul>
                </div>
                 
                 <br />
                 <br />
                 
                 
                <b>JAN 2022 -- MAY 2022 : Assistant Cashier </b>
                    <div className='ms-5 text-start mb-3'>
                        <ul>
                            <li>Supported senior cashiers during busy hours by bagging items and managing queues.</li>
                            <li>Assisted with daily cash counting and preparing financial reports.</li>
                            <li>Ensured all transactions were accurately recorded and compliant with company policies.</li>
                            
                        </ul>
                    </div>
                {/* <div className='breack-page-here'></div> */}
                 
                 

                <br />
                <br />
                <b>JAN 2022 -- MAY 2022 : Stack Manager</b>
                    <div className='ms-5 text-start mb-3'>
                        <ul>
                            <li>Organized and managed the storage of inventory, ensuring products were easily accessible and properly labeled.</li>
                            <li>Conducted regular stock checks to maintain accurate inventory records.</li>
                            <li>Resolved client complaints or escalated them to the appropriate department when necessary.</li>
                            <li>Ensured the sales floor was organized and products were displayed attractively.</li>
                            
                        </ul>
                    </div>
                <br />
                <br />
                <b>JAN 2022 -- MAY 2022 : Client Assistant</b>
                    <div className='ms-5 text-start mb-3'>
                        <ul>
                            <li>Welcomed and assisted clients in finding products that met their needs.</li>
                            <li>Provided personalized recommendations to improve the customer shopping experience.</li>
                            <li>Resolved client complaints or escalated them to the appropriate department when necessary.</li>
                            <li>Ensured the sales floor was organized and products were displayed attractively.</li>
                            
                        </ul>
                    </div>
                <br />
                <br />
                
                 
            </div>


        </div>
    </>);
}

export default CvPage;